import styled, { css } from 'styled-components/macro';
import modularScale from 'styles/helpers/modular-scale';

const ArtworkBorderStyle = css`
  transition: ${({ theme }) =>
    `opacity ${theme.transitionDuration} ${theme.timingFunction}`};
  transform-origin: 50px 50px;
  transform: rotate(-90deg);
  opacity: ${({ showBorder }) => (showBorder ? 1 : 0)};
`;

export const ActiveBorderSquare = styled('rect')`
  ${ArtworkBorderStyle};
`;

export const ActiveBorderCircle = styled('circle')`
  ${ArtworkBorderStyle};
`;

export const ArtworkWrapper = styled('div')`
  width: ${modularScale(9)};
  height: ${modularScale(9)};
  box-sizing: content-box;
  transition: ${({ theme }) =>
    `all ${theme.transitionDuration} ${theme.timingFunction}`};

  svg {
    width: 100%;
    height: 100%;
  }

  @media only screen and (min-width: 40rem) {
    width: ${modularScale(10)};
    height: ${modularScale(10)};
  }
`;

export const ArtworkMask = styled('div')`
  width: 100%;
  height: 100%;
  position: relative;
`;
